export default {
  hero: {
    label: 'Featured releases',
    eyebrow: 'Featured',
    browse: 'Browse catalog',
    goToSlide: 'Go to slide {n}',
  },
  comingSoon: 'Coming soon',
  games: '{count} game | {count} games',
  stats: {
    inStock: 'Keys in stock',
    preorders: 'Pre-orders',
  },
  recent: { title: 'Recently viewed' },
  newest: { title: 'New in store' },
  under5: { title: 'Under 5 €' },
  preorders: { title: 'Pre-orders' },
  how: {
    wallet: 'KeyzoStore wallet',
    invoice: 'PDF receipt per top-up',
    keyNote: 'In your orders and inbox',
    pick: { title: 'Pick a game', body: 'Browse keys that are in stock right now.' },
    pay: { title: 'Pay your way' },
    receive: { title: 'Get your key' },
  },
  genres: {
    title: 'Browse by genre',
  },
  cta: {
    title: 'Create a free account',
    body: 'Save your wishlist, track orders and get your keys in one place.',
  },
};
